import React, { useEffect, useContext } from "react"
import styled from "styled-components"
import { motion, useAnimation } from "framer-motion"

import Context from "../context"
import ContentWrapper from "../styles/contentWrapper"
import Navbar from "./navbar"

const StyledHeader = motion.custom(styled.header`
  width: 100%;
  height: ${({ theme }) => theme.headerHeight};
  background: ${({ theme }) => theme.colors.background};
`)

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`

const Header = () => {
  const { isIntroDone } = useContext(Context).state

  // Required for animation - start after the splashScreen sequence is done
  const controls = useAnimation()
  useEffect(() => {
    if (isIntroDone)
      controls.start({ opacity: 1, y: 0, transition: { delay: 0.2 } })
  }, [isIntroDone, controls])

  return (
    <StyledHeader initial={{ opacity: 0, y: -10 }} animate={controls}>
      <StyledContentWrapper>
        <Navbar />
      </StyledContentWrapper>
    </StyledHeader>
  )
}

export default Header
